module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || "90eldx6v",
    dataset: process.env.GATSBY_SANITY_DATASET || "production"
  }
};
